import { IdentityDialogOptions } from '@treasury/domain/shared';

export const defaultDialogOptions: Omit<IdentityDialogOptions, 'otpRequestFn'> = {
    disableClose: false,
    forLogin: false,
    withoutUserInteraction: false,
};
